var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStafraentIslandLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 669.51 108.09",
    className: "_3Huio",
    width: 200,
    "aria-label": "island.is logo",
    style: {
      color: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.69,
    y1: 3.69,
    x2: 104.39,
    y2: 104.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0161fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3f46d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#812ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c21578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -16.95,
    y1: 24.34,
    x2: 83.75,
    y2: 125.04,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -37.59,
    y1: 44.98,
    x2: 63.11,
    y2: 145.68,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 44.98,
    y1: -37.59,
    x2: 145.68,
    y2: 63.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -16.95,
    y1: 24.34,
    x2: 83.75,
    y2: 125.04,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 3.69,
    y1: 3.69,
    x2: 104.39,
    y2: 104.39,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 24.34,
    y1: -16.95,
    x2: 125.04,
    y2: 83.75,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 3.69,
    y1: 3.69,
    x2: 104.39,
    y2: 104.39,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 24.34,
    y1: -16.95,
    x2: 125.04,
    y2: 83.75,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.44,
    y: 41.72,
    width: 18.92,
    height: 65.94,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.14,
    y: 9.6,
    width: 18.92,
    height: 98.05,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2 41.43c-11.61 0-17.2.1-32.25.29a1.9 1.9 0 00-2.15 2.15v61.64a1.9 1.9 0 002.15 2.15h14.62a1.9 1.9 0 002.15-2.15V55.33h9.75c11.18 0 13.76 3.16 13.76 15.06v35.12a1.9 1.9 0 002.15 2.15H439a1.9 1.9 0 002.15-2.15V65.94c0-19.78-14.33-24.51-26.95-24.51zM515.5 10h-14.63c-1.43 0-2.15.72-2.15 2.73v28.56h-14.91c-14 0-28.81 4.3-28.81 33.4 0 28.38 14.77 33.25 28.81 33.25 18.21 0 23.94-.13 31.69-.28a1.92 1.92 0 002.15-2.15V12.76c0-2.01-.72-2.76-2.15-2.76zm-16.78 84.18h-11.18c-9.89 0-13.62-4.73-13.62-19.21 0-15.19 3.73-19.64 13.62-19.64h11.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.47,
    cy: 95.33,
    r: 12.76,
    transform: "rotate(-3.56 549.91 95.358)",
    fill: "#ff0050"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.9,
    cy: 12.76,
    r: 12.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65 41.43c-11.75 0-18.2.15-25.95.29a2 2 0 00-2.15 2.28v9.17a1.9 1.9 0 002.15 2.15h19.36c11.18 0 14.05 3.16 14.05 8.46v3h-18.5c-14.91 0-23.65 4.59-23.51 19.79.15 16.19 8.75 21.35 23.66 21.35 21.36 0 27.38-.16 35.12-.28a1.91 1.91 0 002.15-2.15v-41c-.03-18.33-14.34-23.06-26.38-23.06zm7.46 52.75h-14.34c-5.88 0-8.6-1.72-8.74-7.59s2.72-7.6 8.6-7.6h14.48zM242.75 70.82l-17.06-5.59c-3.87-1.29-5-2.44-5-5.31 0-3.3 1.72-4.73 7.16-4.73h24.65a1.9 1.9 0 002.15-2.19v-9.28a1.92 1.92 0 00-2.15-2.15c-7.74-.15-14-.28-27.38-.28s-22.94 4-22.94 17.2v2.43c0 7.46 4.73 14.34 14.48 17.64L233 84c4.3 1.44 5 2.3 5 5 0 3.73-1.72 4.88-5.73 4.88h-26.93a1.9 1.9 0 00-2.15 2.15v9.31a1.9 1.9 0 002.15 2.15c7.74.15 13.47.29 26.95.29 16.34 0 24.37-3.87 24.37-17.34V88c0-6.29-2.44-13.46-13.91-17.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.29,
    y: 41.72,
    width: 18.92,
    height: 65.94,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.76,
    cy: 12.76,
    r: 12.76,
    transform: "rotate(-4.07 590.034 12.793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.61 70.82l-17.06-5.59c-3.87-1.29-5-2.44-5-5.31 0-3.3 1.72-4.73 7.17-4.73h24.66a1.9 1.9 0 002.13-2.19v-9.28a1.92 1.92 0 00-2.15-2.15c-7.75-.15-14-.28-27.38-.28S615 45.3 615 58.49v2.43c0 7.46 4.73 14.34 14.48 17.64L645.86 84c4.3 1.44 5 2.3 5 5 0 3.73-1.72 4.88-5.74 4.88h-26.93a1.9 1.9 0 00-2.19 2.17v9.31a1.91 1.91 0 002.15 2.15c7.74.15 13.48.29 26.95.29 16.35 0 24.37-3.87 24.37-17.34V88c.04-6.29-2.39-13.46-13.86-17.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.76 0A12.62 12.62 0 000 12.76a12.62 12.62 0 0012.76 12.76 12.62 12.62 0 0012.76-12.76A12.62 12.62 0 0012.76 0z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 82.57a12.76 12.76 0 1012.8 12.76A12.61 12.61 0 0054 82.57z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.76 82.57a12.76 12.76 0 000 25.52 12.76 12.76 0 000-25.52z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33 25.52a12.62 12.62 0 0012.76-12.76 12.76 12.76 0 00-25.52 0 12.62 12.62 0 0012.76 12.76z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.76 41.29a12.76 12.76 0 100 25.51 12.76 12.76 0 100-25.51z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 41.29A12.76 12.76 0 1066.8 54 12.6 12.6 0 0054 41.29z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33 41.29A12.76 12.76 0 10108.09 54a12.61 12.61 0 00-12.76-12.71z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33 82.57a12.76 12.76 0 1012.76 12.76 12.62 12.62 0 00-12.76-12.76z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 0a12.61 12.61 0 00-12.71 12.76 12.76 12.76 0 1025.51 0A12.62 12.62 0 0054 0z",
    fill: "url(#i)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStafraentIslandLogo);
export default __webpack_public_path__ + "static/media/StafraentIslandLogo.46d29a2d5d7c6cb7f9b6bb5ef5eb0c62.svg";
export { ForwardRef as ReactComponent };